import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// actions + utils
import { updateShopper } from '../../../actions/user';
import { fmtShopper } from '../../../common/utils/format';

// components
import { TextInput } from './components';
import { LoaderButton } from '../../../common/components';

/* eslint-disable no-unused-vars */
function UpdateShopper() {
  const dispatch = useDispatch();
  const {
    birthdate: enrollFormDob,
    home_phone: enrollFormPhone,
  } = useSelector(store => store.values);
  const {
    username: shopperUsername,
    dob: shopperDob,
    homePhone,
    mobilePhone,
  } = useSelector(store => store.shopper);
  const { agentPortalUrl = process.env.REACT_APP_AGENT_PORTAL_DEV_SERVER_URL } = useSelector(store => store.theme);

  const [ loading, setLoading ] = useState(false);
  const [ updateError, setUpdateError ] = useState(false);
  const [ dob, setDob ] = useState(enrollFormDob);
  const [ phone, setPhone ] = useState(enrollFormPhone);

  function handleUpdateShopper() {
    setLoading(true);
    setUpdateError('');
    updateShopper(shopperUsername, { birthdate: dob, home_phone: phone })
      .then(data => {
        dispatch({ type: 'SET_SHOPPER', shopper: fmtShopper(data) });
        if (window.opener) {
          window.opener.postMessage({ requestShopperToRefresh: true }, agentPortalUrl);
        }
      }).catch(() => {
        setUpdateError('Error updating shopper');
      }).finally(() => setLoading(false));
  }

  return (
    <>
      <hr />
      <div className="row">
        <p>
          <i>
            In order for your client to access the esignature option you must populate
            a date of birth and phone number for them. Before you can send them a request
            to esign we must populate this data to their record. Note that this information
            will be used by the client to access the esignature you are sending them.
            Please double check this information is accurate before saving it, or your client
            will not be able to access the esignature!
          </i>
        </p>
      </div>

      <div className="row mt-3">
        {!shopperDob && (
          <TextInput
            required
            type="date"
            label="Shopper's Date of Birth"
            name="shopper-dob"
            value={dob}
            handleChange={(e) => setDob(e.target.value)}
          />
        )}
        {!(homePhone || mobilePhone) && (
          <TextInput
            required
            label="Shopper's phone number"
            name="shopper-phone"
            value={phone}
            handleChange={(e) => setPhone(e.target.value)}
          />
        )}
      </div>

      <div className="row mt-3 mb-5">
        <div className="col-md-6">
          <LoaderButton
            onClick={() => handleUpdateShopper()}
            className="btn btn-primary fw-bold"
            text="Update"
            loadingText="Updating"
            loading={loading}
            disabled={loading}
          />
          <br />
          {updateError && (
            <i className="text-danger">
              {updateError}
            </i>
          )}
        </div>
      </div>
    </>
  );
}

export default UpdateShopper;
